/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */

import { RequestBase } from '../requestBase';
import { APIRoutes } from '../apiRoutes';

export class RequestChannelPasswordReset extends RequestBase {

  public override getAPIEndPoint(): string {
    return APIRoutes.Users_Channel_Password_Reset;
  }

  public channelName : string | undefined = '';
  public userName : string | undefined = '';
}

export class ResponseChannelPasswordReset {
  public result = false;
}
